import {
  Color,
  Header,
  LinkButton,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToTestCases } from '@eggplant/routing'

const EmptyStateNoAssignedTestCase = () =>
  <div className=' grid grid-rows-[auto_auto] gap-4 text-center'>
    <div className='grid w-[450px] grid-rows-[auto_auto] gap-2'>
      <Header
        hasNoTopMargin
        rank={4}
      >
        No assigned test cases yet
      </Header>
      <Paragraph>
        <Color variant='theme-description-text'>
          You must map/assign this requirement to at least one test case step or script and run it in order to see the requirement results here. You can assign a requirement to a test case step/or script on the Test case edit page for a selected test case.
        </Color>
      </Paragraph>
    </div>
    <div>
      <LinkButton>
        <LinkToTestCases>
          Open test case page
        </LinkToTestCases>
      </LinkButton>
    </div>
  </div>

export default EmptyStateNoAssignedTestCase
